import React, { PureComponent } from 'react';

import Landscape from './landscape';
import Portrait from './portrait';

export default class Printable extends PureComponent {
  render() {
    return (
      <>
        <Portrait />
        <Landscape />
      </>
    );
  }
}
